// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.PDP.KitUpFunctionality.View'
,	[
	'c3_shoppingextensions_pdp_kitupfunctionality.tpl'
	
	,	'C3.ShoppingExtensions.PDP.Model'
	,   'AjaxRequestsKiller'
	,	'Backbone'
	,   'Utils'	
	,   'Backbone.CollectionView'
	,   'backbone_collection_view_row.tpl'
	,   'C3.ShoppingExtensions.PDP.KitUpItems.View'
    ]
, function (
	c3_shoppingextensions_pdp_kitupfunctionality_tpl
	
	,	PDPModel
	,   AjaxRequestsKiller
	,	Backbone
	,   Utils
	,   BackboneCollectionView
	,   backbone_collection_view_row_tpl
	,   KitUpItemsView
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_pdp_kitupfunctionality_tpl

	,	initialize: function (options) {
			this.application = options.application;
			this.layout = options.layout;
			this.iteminfo = options.iteminfo;
			this.configuration = options.configuration;
			this.container = options.container;
			
			var configuration = this.configuration;
			this.pdpConfig = configuration.PDP.config;
			
		}


	,  render: function()
	{	
		var self = this;
		
		var item_info = this.iteminfo
		,   item = item_info.item
		,   itemtype = item.itemtype
		,   item_id = item.internalid

		var model = new PDPModel();
		
		model.fetch({
			data: {
                itemid: item_id,
                itemtype : itemtype
            },
            killerId: AjaxRequestsKiller.getKillerId()
		}).done(function (res)
	      {
	      	//Kit up functionality section
	      	var kitUpItemsData = res.kitUpItemsFunctionalityData;
	      	if(kitUpItemsData.length > 0 )
	      	{
	      		const newkitUpItemsData = [item_id].concat(kitUpItemsData[0]) // [ 4, 3, 2, 1 ]
				self.kitupitems = newkitUpItemsData;
		      	self._render(); 
	      	}  	
	      })
	}		

	,	events: {
			'click [data-action="better-together-add-to-bag"]': 'addToBagBTItems'
		}

	,	bindings: {
		}

	, 	childViews: {
			'KitUp.Items' : function (){
				//console.log(this.kitupitems)
				var self = this;
				return new KitUpItemsView({
			          itemsIds: this.kitupitems,
			          application: self.application,
			          configuration : self.configuration,
			          container : self.container,
			          parentItemInfo: this.iteminfo		        
			        });
			}
		}

	,	addToBagBTItems: function(e) {
            // ignore clicks on anchors and buttons
           	var self=this;
            var cart = this.container.getComponent('Cart');
	    	
            //jQuery('.better-together-item-checkbox') 
           	var lines=[];
           	jQuery('.better-together-item-checkbox').each(function () 
            {
                var bTItemInternalID = (this.checked ? jQuery(this).val() : "");
                
                if(bTItemInternalID && bTItemInternalID >0)
                {
                	var lineData={quantity: parseFloat(1),
                	 item: {internalid: parseFloat(bTItemInternalID)}
            		};
            	 	lines.push(lineData);
                }
            });
        	if(lines.length > 0)
        	{
        		SC.loadingIndicatorShow();
	            cart.addLines({lines: lines}).then(function() {
	                SC.loadingIndicatorHide();
	                
	                if(!Utils.isPhoneDevice())
	                     jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
	            });
        	}
        }	
		//@method getContext @return NXTurn.ShoppingExtensions.PDP.View.Context
	,	getContext: function getContext()
		{
			
			return {
				
			};
		}
	});
});
